import { SuggestionContentResponseModel, ImageWithCrops } from '@/services/platform/api/model';
import { ImageMap } from '@/lib/core/utils';

export interface SuggestionMiniCardProps {
  item: SuggestionContentResponseModel;
  onClick: () => void;
}

export function SuggestionMiniCard({ item, onClick }: SuggestionMiniCardProps) {
  const p = item.properties;
  const image = ImageMap((p?.image?.[0] as ImageWithCrops) ?? undefined);
  const venueName = p?.venue?.[0]?.name;

  return (
    <article
      className="flex w-61 shrink-0 cursor-pointer snap-start flex-col gap-2"
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={e => e.key === 'Enter' && onClick()}
    >
      <div className="relative h-80 w-full overflow-hidden rounded-[2px] bg-[#2a2a2a]">
        {image?.src && (
          <img
            src={image.src}
            alt={image.alt ?? p?.title ?? item.name ?? ''}
            className="absolute inset-0 h-full w-full object-cover"
            loading="lazy"
          />
        )}
      </div>

      <div className="flex flex-col gap-2">
        {p?.title && (
          <p className="font-pp-neue-montreal text-[16px] font-normal tracking-[0.25px] text-[#1a1a24]">
            {p.title}
          </p>
        )}
        {(p?.category || venueName) && (
          <p className="font-pp-neue-montreal text-[14px] tracking-[0.5px] text-[#1a1a24]">
            {p?.category && <span className="font-semibold uppercase">{p.category} </span>}
            {venueName && <span className="font-normal">at {venueName}</span>}
          </p>
        )}
      </div>
    </article>
  );
}
